import { useNavigate } from 'react-router-dom';

import { BottomMenuStyled } from './styled';

import clsx from 'clsx';
import Button from 'src/components/Button';

interface BottomMenuProps {
  className?: string;
}

const BottomMenu = ({ className }: BottomMenuProps) => {
  const navigate = useNavigate();

  return (
    <BottomMenuStyled className={clsx('BottomMenu', className)}>
      <Button
        block
        size="large"
        shadow
        onClick={() => {
          navigate('/register');
        }}
      >
        운동 시작하기
      </Button>
    </BottomMenuStyled>
  );
};

export default BottomMenu;
